import { motion } from "framer-motion";
import { TEAM } from "@/constants/testIds";

export default function Team({ members = [] }) {
    return (
        <section
            id="team"
            data-testid={TEAM.root}
            className="relative py-20 md:py-24"
        >
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="max-w-2xl">
                    <p className="text-xs uppercase tracking-[0.35em] text-[var(--accent-gold)] mb-5">
                        The Team
                    </p>
                    <h2 className="font-display font-bold text-3xl md:text-4xl lg:text-5xl leading-[1.05] text-[var(--text-primary)]">
                        One vision.{" "}
                        <span className="italic text-[var(--accent-champagne)]">
                            One system.
                        </span>
                    </h2>
                </div>

                <div className="mt-10 md:mt-14 flex justify-center">
                    {members.map((m, i) => (
                        <motion.div
                            key={m.id}
                            data-testid={TEAM.card(m.id)}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-80px" }}
                            transition={{ duration: 0.6, delay: i * 0.08 }}
                            className="w-full max-w-md rounded-2xl border border-[var(--border-subtle)] hover:border-[var(--border-accent)] bg-[rgba(255,255,255,0.02)] p-5 md:p-6 flex items-start gap-4 transition-colors"
                        >
                            <div className="shrink-0 w-11 h-11 md:w-12 md:h-12 rounded-full bg-[var(--accent-gold)] text-[var(--brand-dark)] flex items-center justify-center font-bold font-display text-lg">
                                {m.name.slice(0, 1).toUpperCase()}
                            </div>
                            <div className="min-w-0">
                                <p className="text-[10px] uppercase tracking-[0.3em] text-[var(--accent-gold)]">
                                    {m.role}
                                </p>
                                <h3 className="font-display text-xl md:text-2xl font-semibold text-[var(--text-primary)] mt-0.5">
                                    {m.name}
                                </h3>
                                <p className="mt-2 text-sm text-[var(--text-secondary)] leading-relaxed">
                                    {m.bio}
                                </p>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
